import { ANALYTICS_EVENTS, ANALYTICS_EVENT_ACTIONS } from '../../utils/constants';
import { CORE_DOWNLOAD_TYPE, GA_PAGE } from './constants';
import React, { useContext } from 'react';

import Button from '@mui/material/Button';
import GetAppIcon from '@mui/icons-material/GetApp';
import { SECURE_COUNTRY_DOWNLOAD_QUERY } from '../../components/Downloads/operations';
import SnackbarContext from '../../contexts/SnackbarContext';
import { getUserId } from '../../utils/auth';
import makeStyles from '@mui/styles/makeStyles';
import { openDownloadUrl } from '../../components/Downloads/helpers';
import { useLazyQuery } from '@apollo/client';

const useStyles = makeStyles((theme) => ({
  button: {
    ...theme.palette.actionCustom,
    alignSelf: 'center',
  },
}));

export default ({ country }) => {
  const classes = useStyles();
  const { setSnack } = useContext(SnackbarContext);
  const dimensions = country ? { asset: 'NULL', country: country.name, company: 'NULL' } : {};
  const countryIsoCode = country ? country.isoCode : null;

  const [getReport] = useLazyQuery(SECURE_COUNTRY_DOWNLOAD_QUERY, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const { url, filename, downloadMessage } = data.secureCountryDownload;
      if (url) {
        setSnack({
          open: true,
          message: `Your download should begin shortly.${downloadMessage}`,
          severity: 'success',
        });
        openDownloadUrl(url, filename);
      }
    },
    onError: (error) => {
      setSnack({
        severity: 'error',
        message: error.message,
        open: true,
      });
    },
  });

  return (
    <Button
      onClick={() => {
        gtag('event', ANALYTICS_EVENTS.event, {
          event_category: GA_PAGE,
          event_action: ANALYTICS_EVENT_ACTIONS.download,
          event_label: 'country_report',
          userId: getUserId(),
          ...dimensions,
        });
        getReport({ variables: { countryIsoCode, downloadType: CORE_DOWNLOAD_TYPE } });
      }}
      disabled={!country}
      className={classes.button}
      variant="contained"
    >
      <GetAppIcon fontSize="small" />
      &nbsp;country overview
    </Button>
  );
};
